import whitelabel from "./whitelabel";

export const mapboxUsername = whitelabel.mapboxStyle.username;
export const mapboxStyleID = whitelabel.mapboxStyle.styleID;
export const mapboxStyle = `mapbox://styles/${mapboxUsername}/${mapboxStyleID}`;

export const mapboxStyleSatelliteID = "clb5beops000d14nv8rtide2k";
export const mapboxStyleSatellite = `mapbox://styles/${mapboxUsername}/${mapboxStyleSatelliteID}`;

export const supportURL = whitelabel.supportURL;
export const hardwareSetupSupportURL = whitelabel.hardwareSetupSupportURL;
